/*  Shared  */
import { DateFormat } from 'application/Shared/Components/Core';

/*  React  */
import React from 'react';

export const DateFormatNoTimeStringCell = (props) => {
    const { cell, row, ...rest } = props;
    return (
        <DateFormat
            date={row.original[cell.column.columnDef.accessorKey]}
            noTz
            noTimeString
            {...rest}
        />
    );
};
